import z from "zod";
import { worksites } from "../../../attendances";
import { attendanceWorksiteRefine } from "../attendance-form.schema";

export const getCheckInRequirementsQuerySchema = z
	.object({
		worksite: z.enum(worksites),
		projectId: z.uuid().optional(),
	})
	.superRefine(attendanceWorksiteRefine);

export type GetCheckInRequirementsQuerySchema = z.infer<typeof getCheckInRequirementsQuerySchema>;
